/**
 * Valores iniciais do formulário de Role/Cargo.
 */
export const roleDefaults = {
    name: "",
    description: "",
    status: "active",
    permissions: {},
};
